<template>
    <div class="maindiv">
        <div class="pubclass">首页</div>
        <div class="pubclass">科室分类</div>
        <div class="pubclass">发布时间</div>
        <div class="pubclass">搜索</div>
    </div>
</template>
<script>
export default {
  name: 'Nav',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.maindiv{
    float: left;
    width: 100%;
}
.pubclass{
    float: left;
    font-size: 0.16rem;
    width: 25%;
    line-height: 0.45rem;
    height: 0.45rem;
    background: #999;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue